export const DATE_SHORTCUTS = ['Current Week', 'Last Week', 'MTD', 'Last Month'] as const;
export type DateShortcut = typeof DATE_SHORTCUTS[number];

// Use local calendar arithmetic across DST and month/year boundaries.
// Current periods end today, matching the reports' prohibition on future dates.
export function shortcutRange(shortcut: DateShortcut, now = new Date()): [Date, Date] {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const sunday = new Date(today);
  sunday.setDate(today.getDate() - today.getDay());
  switch (shortcut) {
    case 'Current Week': return [sunday, today];
    case 'Last Week': {
      const start = new Date(sunday);
      start.setDate(start.getDate() - 7);
      const end = new Date(sunday);
      end.setDate(end.getDate() - 1);
      return [start, end];
    }
    case 'MTD': return [new Date(today.getFullYear(), today.getMonth(), 1), today];
    case 'Last Month': return [
      new Date(today.getFullYear(), today.getMonth() - 1, 1),
      new Date(today.getFullYear(), today.getMonth(), 0),
    ];
  }
}

export function metricsDateShortcuts(onSelect: (start: Date, end: Date) => void) {
  return DATE_SHORTCUTS.map((label) => ({ label, onSelect: () => onSelect(...shortcutRange(label)) }));
}
